/**
 * Standalone airline landing page settings for flynodex.com.
 * Kept separate from the home page and /flight app — edit values here only.
 */

export const SW_BRAND = 'FlyNodex';
export const SW_BRAND_ACCENT = 'Nodex';
export const SW_LOGO_BY = 'Nodex Global LLC';
export const SW_DOMAIN = 'flynodex.com';
export const SW_TAGLINE = 'Compare live fares and get booking help any hour';

export const SW_PHONE = '1-877-479-3948';
export const SW_PHONE_RAW = '+18774793948';
export const SW_PHONE_DISPLAY = '+1 (877) 479-3948';
export const SW_EMAIL = 'info@nodexgloballlc.com';

export const SW_NAV = [
  { label: 'Home', href: '#swp-top' },
  { label: 'Flights', href: '#swp-search' },
  { label: 'Guide', href: '#swp-guide' },
  { label: 'FAQs', href: '#swp-faq' },
  { label: 'Contact', href: '#swp-contact' },
];

export const SW_DISCLAIMER = [
  `${SW_BRAND} (${SW_DOMAIN}) operates as an independent travel booking assistance service. We are not an airline and we are not affiliated with, endorsed by, or sponsored by any carrier named on this page.`,
  'Carrier names, logos, trademarks, and route details belong to their respective owners and appear here only for identification and descriptive purposes.',
  'Any sample fares are illustrative and may change without notice based on availability at ticketing. Baggage rules, change conditions, refunds, and loyalty benefits are set by the operating airline and always take priority over information shown here.',
];
